var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import cx from 'classnames';
import { NumberInput } from '../NumberInput/NumberInput';
import styles from './CurrencyInput.module.css';
export var Position;
(function (Position) {
    Position["Right"] = "right";
    Position["Left"] = "left";
})(Position || (Position = {}));
export var CurrencyInput = function (_a) {
    var _b, _c, _d;
    var currency = _a.currency, _e = _a.currencyPosition, currencyPosition = _e === void 0 ? Position.Left : _e, labelClassName = _a.labelClassName, className = _a.className, iconContainerClassName = _a.iconContainerClassName, rest = __rest(_a, ["currency", "currencyPosition", "labelClassName", "className", "iconContainerClassName"]);
    var icon = React.createElement(Fragment, null, currency);
    var left = currencyPosition === Position.Left;
    return (React.createElement(NumberInput, __assign({}, rest, (_b = {}, _b[left ? 'iconLeft' : 'iconRight'] = icon, _b), { labelClassName: cx(styles.label, labelClassName), className: cx(styles.input, (_c = {}, _c[styles.inputWithLeftIcon] = left, _c), className), iconContainerClassName: cx(styles.icon, (_d = {},
            _d[styles.left] = left,
            _d[styles.right] = !left,
            _d[styles.noLabel] = !rest.label || rest.isLabelScreenReaderOnly,
            _d), iconContainerClassName) })));
};
//# sourceMappingURL=CurrencyInput.js.map